$(document).ready(function(){
  $('.product__text.review-alignment').on('click', function(e){
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $("#shopify-block-judge_me_reviews_review_widget_kVYXYM").offset().top
    }, 2000);
  })
   function initSlider() {
  $('.wc-template-index .new-featured-collection-slider').slick({
        infinite: true,
        speed: 500,
        slidesToShow: 4,
    adaptiveHeight: true,
        slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29"><g id="Group_7065" data-name="Group 7065" transform="translate(28.814 28.814) rotate(180)"><circle id="Ellipse_1" data-name="Ellipse 1" cx="14.5" cy="14.5" r="14.5" transform="translate(-0.186 -0.186)" fill="#1a1818"></circle><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M3.3,4.13.173,1.006A.59.59,0,0,1,1.01.172L4.551,3.712a.589.589,0,0,1,.017.814L1.012,8.09a.59.59,0,0,1-.836-.834Z" transform="translate(12.102 10.373)" fill="#fff"></path></g></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg id="Group_7064" data-name="Group 7064" xmlns="http://www.w3.org/2000/svg" width="28.814" height="28.814" viewBox="0 0 28.814 28.814"><path id="Path_30465" data-name="Path 30465" d="M14.407,0A14.407,14.407,0,1,1,0,14.407,14.407,14.407,0,0,1,14.407,0Z" fill="#1a1818"></path><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M14.55,10.324,11.424,7.2a.59.59,0,0,1,.836-.834L15.8,9.905a.589.589,0,0,1,.017.814l-3.557,3.564a.59.59,0,0,1-.836-.834Z" transform="translate(0.851 4.179)" fill="#fff"></path></svg></button>',
        //autoplay: true,
       // autoplaySpeed: 2000,
        arrows: true,
        responsive: [
        {
           breakpoint: 1200,
           settings: {
              slidesToShow: 3,
              slidesToScroll: 1
           }
        },
        {
           breakpoint: 767,
           settings: {
             centerMode:true,
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });
 }
        // if ($(window).width() > 768) {
        //     initSlider();
        // }
        // $(window).resize(function(){
        //     if ($(window).width() > 768) {
        //         initSlider();
        //     } else {
        //       initSlider();
        //       //  $('.wc-template-index .new-featured-collection-slider').slick('unslick');
        //     }
        // });

  initSlider();

  $('.wc-template-index .certification_sec').slick({
		rows: 1,
		dots: true,
		arrows: false,
		infinite: true,
		speed: 300,
		slidesToShow: 6,
		slidesToScroll: 6,
     prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29"><g id="Group_7065" data-name="Group 7065" transform="translate(28.814 28.814) rotate(180)"><circle id="Ellipse_1" data-name="Ellipse 1" cx="14.5" cy="14.5" r="14.5" transform="translate(-0.186 -0.186)" fill="#1a1818"></circle><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M3.3,4.13.173,1.006A.59.59,0,0,1,1.01.172L4.551,3.712a.589.589,0,0,1,.017.814L1.012,8.09a.59.59,0,0,1-.836-.834Z" transform="translate(12.102 10.373)" fill="#fff"></path></g></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg id="Group_7064" data-name="Group 7064" xmlns="http://www.w3.org/2000/svg" width="28.814" height="28.814" viewBox="0 0 28.814 28.814"><path id="Path_30465" data-name="Path 30465" d="M14.407,0A14.407,14.407,0,1,1,0,14.407,14.407,14.407,0,0,1,14.407,0Z" fill="#1a1818"></path><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M14.55,10.324,11.424,7.2a.59.59,0,0,1,.836-.834L15.8,9.905a.589.589,0,0,1,.017.814l-3.557,3.564a.59.59,0,0,1-.836-.834Z" transform="translate(0.851 4.179)" fill="#fff"></path></svg></button>',
        autoplay: true,
       autoplaySpeed: 4000,
    responsive: [
        {
           breakpoint: 768,
           settings: {
              slidesToShow: 4,
		slidesToScroll: 4,
           }
        }
      ]
});
      $('a.featured_btn.grid_buy_now').click(function(e) {
        e.preventDefault();

        var productId = $(this).data('id');
        var quantity = 1; // Set the quantity of the product you want to add to the cart

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: productId,
                quantity: quantity
            },
            dataType: 'json',
            success: function(data) {
                console.log('Product added to cart', data);
                window.location.href = '/checkout'; // Redirect to the checkout page
            },
            error: function(xhr, status, error) {
                console.error('Error adding product to cart', xhr, status, error);
                alert('Sorry, there was an error adding the product to your cart.');
            }
        });
    });
})